export const SESSION_AGE = import.meta.env.VITE_SESSION_AGE;
export const IDLE_TIMEOUT = import.meta.env.VITE_IDLE_TIMEOUT;

export const STUDENT = "student";
export const MERCHANT = "merchant";
export const SCANNER = "scanner";
export const KITCHEN = "kitchen";

export const TX_TRANSFER = "transfer";
export const TX_WITHDRAWAL = "withdrawal";
export const TX_VOUCHER = "voucher";
export const TX_REFUND = "refund";
export const TX_DEPOSIT = "deposit";

export const STATUS_COMPLETE = "Complete";
export const STATUS_FAILED = "Failed";
export const STATUS_PROCESSING = "Processing";
export const STATUS_INITIALIZED = "Initialized";
export const STATUS_PENDING = "Pending";
export const STATUS_CANCELLED = "Cancelled";

// Firestore collections for the kitchen order pipeline: the raw orders written
// by slide-django-adaptor, and the per-day rollups the cloud-functions triggers
// maintain from them.
export const KITCHEN_ORDERS_COLLECTION = "kitchen-orders";
export const KITCHEN_ORDERS_DAY_AGG_COLLECTION =
  "kitchen-orders-day-aggregations";

export const mealOptions = [
  { value: "Breakfast", label: "Breakfast" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
];

export const questionOptions = [
  { value: "text", label: "Text" },
  { value: "multiple_choice", label: "Multiple Choice" },
  { value: "rank", label: "Rating" },
];

export const voucherTypeOptions = [
  { value: "Standard", label: "Standard" },
  { value: "Top up", label: "Top up" },
];

export const userOptions = [
  { value: "Admin User", label: "Admin User" },
  { value: "Merchant", label: "Merchant" },
  { value: "Scanner", label: "Scanner" },
  { value: "Kitchen User", label: "Kitchen User" },
];

export const statusOptions = [
  { value: "pending", label: "Pending" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const systemStateOptions = [
  { value: "Normal", label: "Normal" },
  {
    value: "Emergency Residences Closed",
    label: "Emergency Residences Closed",
  },
  { value: "Emergency Campus Closed", label: "Emergency Campus Closed" },
];
